import React, { useState, useEffect, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { toast } from 'react-toastify';
import { useParams, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import classNames from 'classnames';
import RECAPTCHA from 'react-google-recaptcha';
// import Collapse from '../shared/Collapse';
import { getData, postData } from '../../services/fetch-service';
import BlockContact from '../blocks/BlockContact';

function getCoordinates(gps) {
    if (gps == null) {
        return null;
    }
    const value = String(gps).trim();
    if (!value || value === 'null' || value === 'undefined') {
        return null;
    }
    const parts = value.split(',').map((part) => part.trim()).filter(Boolean);
    if (parts.length < 2) {
        return null;
    }
    const lat = Number.parseFloat(parts[0]);
    const lng = Number.parseFloat(parts[1]);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
        return null;
    }
    if (lat < -90 || lat > 90 || lng < -180 || lng > 180) {
        return null;
    }
    return { lat, lng };
}

function contact(props) {
    const url = window.location.pathname.split('/').pop();
    const history = useHistory();
    const params = useParams();
    const { locale } = props;
    const captchaRef = useRef(null);
    // const [contactData, setContactData] = useState([]);
    const [pika, setPikat] = useState('');
    const [ddlcontact, setDdlContact] = useState([]);
    const [error, setError] = useState(null);
    const [errorMessage, seterrorMessage] = useState('');
    const [contact, setContact] = useState({
        name: '',
        email: '',
        subject: '',
        message: '',
        contactId: 0,
    });
    const isMainContact = String(params.id) === '8';
    useEffect(() => {
        setContact({
            name: '',
            email: '',
            subject: '',
            message: '',
            contactId: 0,
        });
        setDdlContact([]);
        getData(`Contact/GetContacts?PageID=${params.id}&Gjuha=${locale}`).then((response) => {
            // setContactData(response.data);
            setPikat(response.data[0]);
        }).catch(() => {
            history.push('/404');
        })

        getData(`Contact/GetContactsList?PageID=${params.id}&Gjuha=${locale}`).then((response) => {
            setDdlContact(response.data || []);
        });
    }, [url, locale]);
    const pageContacts = isMainContact ? [] : ddlcontact;
    useEffect(() => {
        if (!pageContacts.length) {
            return;
        }
        setContact((current) => {
            const known = pageContacts.some((item) => String(item.kontaktiId) === String(current.contactId));
            if (known) {
                return current;
            }
            return {
                ...current,
                contactId: pageContacts[0].kontaktiId,
            };
        });
    }, [pageContacts]);
    const clearFields = () => {
        setContact({
            name: '',
            email: '',
            subject: '',
            message: '',
            contactId: isMainContact ? 0 : contact.contactId,
        });
    }

    function isValidEmail(email) {
        return /\S+@\S+\.\S+/.test(email);
    }

    let depatmentSelect;
    if (locale === 'sq') {
        depatmentSelect = (
            <option value="0">Zgjedh</option>
        )
    } else if (locale === 'en') {
        depatmentSelect = (
            <option value="0">Select</option>
        )
    } else if (locale === 'sr') {
        depatmentSelect = (
            <option value="0">Izaberite</option>
        )
    }

    const sendData = () => {
        const token = captchaRef.current.getValue();
        let error = false;
        seterrorMessage('Të gjitha fushat janë obligative');
        if (token === null || token.trim().length === 0) {
            error = true;
        } else if (contact.name.trim().length === 0) {
            error = true;
        } else if (contact.subject.trim().length === 0) {
            error = true;
        } else if (contact.message.trim().length === 0) {
            error = true;
        } else if (contact.contactId === 0 || contact.contactId === '0') {
            error = true;
        } else if (!isValidEmail(contact.email)) {
            error = true;
            seterrorMessage('Formati i Email-it nuk është në rregull');
        }
        if (error === false) {
            postData(`Contact/SendMail?token=${token}`, contact)
                .then((response) => {
                    if (response.data === false) {
                        toast.error('Gabim gjatë dergimit te mesazhit', { theme: 'colored' });
                        captchaRef.current.reset();
                    } else {
                        toast.success('Mesazhi u dërgua me sukses', { theme: 'colored' });
                        clearFields();
                        captchaRef.current.reset();
                    }
                });
            setError(null);
        } else {
            setError(true);
            // toast.error(message, { theme: 'colored' });
        }
    }

    const handleChange = (e) => {
        e.preventDefault();
        setContact({
            ...contact,
            [e.target.name]: e.target.value,
        });
    }

    let inputClass = classNames('')

    if (error === true) {
        inputClass = classNames('form-control');
    } else {
        inputClass = classNames('form-control');
    }

    const coordinates = getCoordinates(pika && pika.gps);
    const mapSrc = coordinates
        ? `https://maps.google.com/maps?q=${coordinates.lat},${coordinates.lng}&hl=es;z=14&output=embed`
        : '';
    const isClassic = isMainContact;
    const map = coordinates ? (
        <div className="contact-us__map">
            <iframe
                title="Google Map"
                src={mapSrc}
                frameBorder="0"
                scrolling="no"
                marginHeight="0"
                marginWidth="0"
            />
        </div>
    ) : null;
    return (
        <React.Fragment>
            <div className="block contact-block">
                <div>
                    <div className={`mb-0 contact-us ${isClassic ? 'contact-us--classic' : 'contact-us--detail'}`}>
                        {!isMainContact && map}
                        <div className="contact-body">
                            <div className="contact-us__container">
                                <div className={`contact-box-grid ${isClassic ? 'contact-box-grid--classic' : ''}`}>
                                    {isClassic && pika && pika.pageName ? <h1 className="contact-page-title">{pika.pageName}</h1> : null}
                                    <div className="contact-classic-boxes">
                                        <BlockContact
                                            isMainContact={isMainContact}
                                            contactsList={pageContacts}
                                            selectedId={contact.contactId}
                                            onSelect={(contactId) => setContact((current) => ({ ...current, contactId }))}
                                        />
                                    </div>
                                    <div className="contact-input-grid">
                                        <div className="">
                                            <div className="contact-box input-c-box">
                                                <h4 className="contact-us__header card-title"><FormattedMessage id="Contact.FormName" defaultMessage="Mesazhi" /></h4>
                                                <form>
                                                    <div className="form-row">
                                                        {isClassic && (
                                                            <div className="form-group col-md-12">
                                                                <label htmlFor="contactId">
                                                                    <FormattedMessage id="contact.label" defaultMessage="Contact" />
                                                                </label>
                                                                <select id="contactId" className={inputClass} name="contactId" value={String(contact.contactId)} onChange={handleChange}>
                                                                    {depatmentSelect}
                                                                    {ddlcontact.map((dep) => <option key={dep.kontaktiId} value={String(dep.kontaktiId)}>{dep.kontaktiPershkrimi}</option>)}
                                                                </select>
                                                            </div>
                                                        )}
                                                        <div className="form-group col-md-6">
                                                            <label htmlFor="name">
                                                                <FormattedMessage id="Contact.FormEmri" defaultMessage="Emri" />
                                                            </label>
                                                            <input type="text" id="name" name="name" value={contact.name} required onChange={handleChange} className={inputClass} />
                                                        </div>
                                                        <div className="form-group col-md-6">
                                                            <label htmlFor="email">
                                                                <FormattedMessage id="Contact.FormEmail" defaultMessage="Email" />
                                                            </label>
                                                            <input
                                                                type="email"
                                                                id="email"
                                                                name="email"
                                                                className={inputClass}
                                                                value={contact.email}
                                                                required
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="subject">
                                                            <FormattedMessage id="Contact.FormSubject" defaultMessage="Subjekti" />
                                                        </label>
                                                        <input type="text" id="subject" name="subject" value={contact.subject} required onChange={handleChange} className={inputClass} />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="message">
                                                            <FormattedMessage id="Contact.FormMessage" defaultMessage="Mesazhi" />
                                                        </label>
                                                        <textarea id="message" name="message" value={contact.message} required onChange={handleChange} className={inputClass} rows="4" />
                                                    </div>
                                                    <div className="captcha-box">
                                                        {error && <h5 style={{ color: 'red' }}>{errorMessage}</h5>}
                                                        <RECAPTCHA
                                                            className="form-group captcha"
                                                            sitekey={process.env.REACT_APP_SITE_KEY}
                                                            ref={captchaRef}
                                                        />
                                                    </div>
                                                    <button type="button" onClick={sendData} className="btn btn-primary">
                                                        <FormattedMessage id="Contact.SendButton" defaultMessage="Dërgo" />
                                                    </button>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                    {isClassic && map}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(contact);
